import maxValue from 'lodash.max';

export const calculateHazMat = (volume = 0, weight = 0) => {
  return maxValue([5000, 600 * (volume || 0), +(((weight || 0) / 800) * 600).toFixed(0)]);
}
